module.exports = __webpack_public_path__ + "img/down-bg.6b38697f.png";